import React, { createContext, useContext, useEffect, useState } from "react";

const LowDataCtx = createContext(null);

export function LowDataProvider({ children }) {
  const [lowData, setLowData] = useState(() => {
    try { return localStorage.getItem("mv_low_data") === "1"; } catch { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem("mv_low_data", lowData ? "1" : "0"); } catch {}
    document.documentElement.classList.toggle("mv-low-data", lowData);
  }, [lowData]);

  return (
    <LowDataCtx.Provider value={{ lowData, setLowData, toggle: () => setLowData((v) => !v) }}>
      {children}
    </LowDataCtx.Provider>
  );
}

export const useLowData = () => useContext(LowDataCtx) || { lowData: false, setLowData: () => {}, toggle: () => {} };
